import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { map } from 'rxjs/operators';
import 'rxjs/add/operator/map';


@Injectable()
export class FunderUsersService {

  constructor(
    public http: HttpClient
  ) {
  }

  createFunderUser(params) {
    const url = `${environment.URL_SERVICIOS}/funder_users`;
    return this.http.post(url, params).pipe(
      map( (resp: any) => {
        return resp;
      } )
    );
  }

  getFunderUsers() {
    const url = `${environment.URL_SERVICIOS}/funder_users`;
    return this.http.get(url).pipe(
      map( (resp: any) => {
        return resp;
      } )
    );
  }

  getFunderUser(id) {
    const url = `${environment.URL_SERVICIOS}/funder_users/${id}`;
    return this.http.get(url).pipe(
      map( (resp: any) => {
        return resp;
      } )
    );
  }

  deleteFunderUser(id) {
    const url = `${environment.URL_SERVICIOS}/funder_users/${id}`;
    return this.http.delete(url).pipe(
      map( (resp: any) => {
        return resp;
      } )
    );
  }

}
